import CheckoutComponentReducers from 'yoda-checkout-components/lib/reducers';
import AccountComponentReducers from 'yoda-account-components/lib/reducers';
import ProductDetailsReducer from 'yoda-site-components/lib/reducers/ProductDetailsReducer';
import PdpNameSpaceReducerCreator from 'yoda-site-components/lib/reducers/PdpNameSpaceReducerCreator';
import CouponsReducer from 'yoda-site-components/lib/reducers/CouponsReducer';
import FindStoresReducer from 'yoda-site-components/lib/reducers/FindStoresReducer';
import CreateAccountReducer from 'yoda-site-components/lib/reducers/CreateAccountReducer';
import SessionReducer from 'yoda-site-components/lib/reducers/SessionReducer';
import AppliedAdjustmentsReducer from 'yoda-site-components/lib/reducers/AppliedAdjustmentsReducer';
import UpdatedAdjustmentReducer from 'yoda-site-components/lib/reducers/UpdatedAdjustmentReducer';
import MessagesReducer from 'yoda-site-components/lib/reducers/MessagesReducer';
import WebvitalsReducer from 'yoda-site-components/lib/reducers/WebvitalsReducer';
import MetaTokenProviderReducer from 'yoda-site-components/lib/reducers/MetaTokenProviderReducer';
import SYFQuickScreenReducer from 'yoda-account-components/lib/reducers/SYFQuickScreenReducer';
import PLCCDynamicBanerReducer from 'yoda-site-components/lib/reducers/PlccDynamicBannerReducer';
import UpdateAdjustmentStatusReducer from './UpdateAdjustmentStatusReducer';
import CartDetailsReducer from './CartDetailsReducer';
import OrderInfoReducer from './OrderInfoReducer';
import CartItemsReducer from './CartItemsReducer';
import OrderTotalsReducer from './OrderTotalsReducer';
import OrderAdjustmentsReducer from './OrderAdjustmentsReducer';
import OrderChargesReducer from './OrderChargesReducer';
import CertonaAttributesReducer from './CertonaAttributesReducer';
import LoadEmptyCartReducer from './LoadEmptyCartReducer';
import CartAnalyticsReducer from './CartAnalyticsReducer';
import UpdateCartItemInitReducer from './UpdateCartItemInitReducer';
import MarketingSlotBannerReducer from './MarketingSlotBannerReducer';
import SFLActionStatusReducer from './SFLActionStatusReducer';
import ItemsQuantityChangedReducer from './ItemsQuantityChangedReducer';
import GiftCardReducer from './GiftCardReducer';
import GiftCardBannerReducer from './GiftCardBannerReducer';
import LastRemovedCartItemReducer from './LastRemovedCartItemReducer';
import NudgeAlertReducer from './NudgeAlertReducer';

const rootReducer = {
    /**
     * Why is it added here? Passed as props from:
     * src/containers/Pages/GiftCard/GiftCardBalance.jsx to
     * src/containers/Pages/GiftCard/components/GiftCardForm.jsx component
     * src/containers/Pages/GiftCard/components/UIComponents/CardGrid/CardGrid.jsx
     * src/containers/Pages/GiftCard/utility/giftCardValidation.js
     * Used as selector data in:
     * src/sagas/GiftCardSaga.js
     */
    giftCard: GiftCardReducer,
    /**
     * Why is it added here? Passed as props from:
     * src/components/EditSilverItem/EditSilverItem.jsx - not rendered anywhere. confirm with team and remove component and lazychunk
     * src/components/GiftCardBanner/GiftCardBanner.jsx - not used so remove prop
     * src/containers/Pages/Cart/CartPage.jsx
     * src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     * src/containers/Pages/SignIn/SignInPage.jsx
     * Used as selector data in:
     * src/sagas/GiftCardBannerSaga.js
     * src/sagas/CartDetailsSaga.js
     * src/sagas/SingleClickCheckoutSaga.js
     *
     */
    cartDetails: CartDetailsReducer,
    /**
     * Why is it added here? Passed as props from:
     * src/components/CartItem/CartItem.jsx
     * src/containers/Pages/Cart/CartPage.jsx
     * src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     * src/components/ItemFulfillmentsNew/ItemFulfillmentsNew.jsx
     * src/components/ItemFulfillmentsNew/BopisFulfillmentNew/BopisFulfillmentNew.jsx
     * src/components/ItemFulfillmentsNew/HomeOrStoreFulfillment/HomeOrStoreFulfillment.jsx
     */
    orderInfo: OrderInfoReducer,
    /**
     * Why is it added here? Passed as props from:
     * src/components/EditSilverItem/EditSilverItem.jsx - not rendered anywhere. confirm with team and remove component and lazychunk
     * src/components/RemoveItem/RemoveItem.jsx
     * src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     */
    orderItems: CartItemsReducer,
    /**
     * Why is it added here? Passed as props from:
     * src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx to
     * src/components/CartItemsList/CartItemsList.jsx
     */
    lastRemovedCartItem: LastRemovedCartItemReducer,
    /**
     * Why is it added here? Passed as props from:
     * src/components/EditSilverItem/EditSilverItem.jsx - not rendered anywhere. confirm with team and remove component and lazychunk
     * src/containers/Pages/Cart/CartPage.jsx
     * src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     */
    orderTotals: OrderTotalsReducer,
    /**
     * Why is it added here? Passed as props from:
     * src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     */
    orderAdjustments: OrderAdjustmentsReducer,
    /**
     * Why is it added here? Passed as props from:
     * src/components/ItemFulfillmentsNew/ItemFulfillmentsNew.jsx
     * src/components/ItemFulfillmentsNew/HomeOrStoreFulfillment/HomeOrStoreFulfillment.jsx
     * src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     */
    orderCharges: OrderChargesReducer,
    /**
     * Why is it added here? Passes as props from:
     * src/containers/Pages/Cart/CartPage.jsx
     */
    certonaAttributes: CertonaAttributesReducer,
    /**
     * Why is it added here? Passed as props from:
     * src/components/PLCCDynamicBanner/PLCCDynamicBanner.jsx - not used by child. so remove prop
     * src/components/SavedItemsProductCartridge/SavedItemsProductCartridge.jsx - not rendered because featureflag is always true. confirm with team and remove
     * src/containers/Pages/Cart/CartPage.jsx
     * src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     */
    loadEmptyCart: LoadEmptyCartReducer,
    /**
     * Why is it added here? Passed as props from:
     * src/containers/Pages/Cart/CartPage.jsx
     * src/containers/Pages/SignIn/SignInPage.jsx
     */
    analyticsClickEvent: CartAnalyticsReducer,
    /**
     * Why is it added here? Passed as props from:
     * src/components/CartItem/CartItem.jsx
     * src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     */
    updateCartItemInit: UpdateCartItemInitReducer,
    /**
     * Why is it added here? Passed as props from:
     * src/components/MarketingS1Slot/MarketingS1Slot.jsx
     * src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     */
    marketingSlotBanner: MarketingSlotBannerReducer,
    /**
     * Why is it added here? Passed as props from:
     * src/components/SavedItemsProductCartridge/SavedItemAddToCartMessage.jsx
     * src/containers/Pages/Cart/CartPage.jsx
     */
    sflActionStatus: SFLActionStatusReducer,
    /**
     * Why is it added here? Passed as props from:
     * src/components/PLCCDynamicBanner/PLCCDynamicBanner.jsx
     * src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     */
    plccDynamicBanner: PLCCDynamicBanerReducer,
    /**
     * Why is it added here? Passed as props from:
     * src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     */
    quantityChangedItems: ItemsQuantityChangedReducer,
    /**
     * Why is it added here? Passed as props from:
     * src/components/GiftCardBanner/GiftCardBanner.jsx
     * src/components/GiftCardBanner/GiftCardBannerMessage.jsx
     * src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     */
    giftCardBannerData: GiftCardBannerReducer,
    productDetails: PdpNameSpaceReducerCreator(ProductDetailsReducer, false, 'productDetails'),
    /**
     * BOF get coupon
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/NewCheckoutPage/NewCheckoutPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/Review/ReviewPage.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/LazyModules/CartPageModalsLazy.jsx
     */
    coupons: CouponsReducer,
    /**
     * find stores
     * yoda-microsite-cart/src/components/ItemFulfillmentsNew/ShipToHomeOrBopisOption/ShipToHomeOrBopisOption.jsx
     * yoda-microsite-cart/src/components/ItemFulfillmentsNew/ShowDetailedFulfillments/ShowDetailedFulfillments.jsx
     * yoda-microsite-checkout/src/sagas/ShipToStoreSaga.js - in microsite
     * yoda-microsite-pdp/src/components/AddToCart/AddToCart.jsx
     * yoda-microsite-pdp/src/components/DeliveryOption/DeliveryOption.jsx
     * yoda-microsite-pdp/src/components/GeneralInformation/GeneralInformation.jsx
     * yoda-microsite-checkout/src/containers/Pages/NewShippingPage/ShipToStoreContainer/ChangeStoreOptions/ChangeStoreOptions.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     * yoda-microsite-pdp/src/components/DeliveryOption/DeliveryOption.jsx
     * yoda-microsite-pdp/src/components/AddToCart/AddToCart.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     * yoda-microsite-pdp/src/components/DeliveryOption/DeliveryOption.jsx
     */
    findStoresDetails: FindStoresReducer,
    /**
     * cart update adjustment
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     */
    updateAdjustmentStatus: UpdateAdjustmentStatusReducer,
    /**
     * create account
     * yoda-microsite-cart/src/containers/Pages/SignIn/components/CreateAccountButton/CreateAccountButton.jsx
     * yoda-microsite-account/src/App.jsx
     * yoda-microsite-rewards/src/containers/Pages/LaunchNLearn/LaunchNLearnConnect.jsx
     */
    CreateAccount: CreateAccountReducer,
    /**
     * session management
     * yoda-microsite-checkout/src/containers/Pages/Review/ReviewPage.jsx
     * yoda-microsite-cart/src/components/SingleClickCheckoutWrapper/SingleClickCheckoutWrapper.jsx
     * yoda-microsite-cart/src/containers/Pages/SignIn/SignInPage.jsx
     * yoda-microsite-checkout/src/LazyModules/LazyModules.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/LazyModules/CartPageModalsLazy.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/NewCheckoutPage/NewCheckoutPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/NewPaymentPage/NewPaymentPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/OrderConfirmation/OrderConfirmationPage.jsx
     * yoda-site-components/src/components/YodaHeader/Header.jsx
     */
    session: SessionReducer,
    /**
     * get applied coupon
     * yoda-site-components/src/sagas/AdjustmentSaga.js (coupon, cart, checkout, coupon drawer)
     * yoda-microsite-marketing/src/containers/Pages/Marketing/Marketing.jsx
     * Coupon drawer
     * Coupon page IRIS component "couponlist"
     */
    appliedAdjustments: AppliedAdjustmentsReducer,
    /**
     * get adjustment update status
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     * yoda-site-components/src/sagas/AdjustmentSaga.js (coupon, cart, checkout, coupon drawer)
     * Coupon page IRIS component "couponlist"
     * Coupon drawer
     */
    isAdjustmentsUpdated: UpdatedAdjustmentReducer,
    /**
     * messages on various pages
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/NewCheckoutPage/NewCheckoutPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/Review/ReviewPage.jsx
     * Coupon drawer
     * Coupon page IRIS component "couponlist"
     */
    messages: MessagesReducer,
    syfQuickScreen: SYFQuickScreenReducer,
    nudgeAlert: NudgeAlertReducer,
    metaTokenInfo: MetaTokenProviderReducer,
    webvitals: WebvitalsReducer,
    ...CheckoutComponentReducers,
    ...AccountComponentReducers,
};

export default rootReducer;
